module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor06-a636c34f187404677288367efb9681df.pdf";